export const NumberToBitArray = (value: number): boolean[] => {
    const arr: boolean[] = [];

    for (let i = 7; i >= 0; i--) {
        const bit: boolean = !!(value & (1 << i));
        arr.push(bit);
    }

    return arr;
};

export const BitArrayToNumber = (value: boolean[]): number => {
    return value.reduce((res: number, x: boolean): number => {
        return (res << 1) | (x ? 1 : 0);
    }, 0);
};

export const ByteArrayToNumber = (bytes: number[]): number => {
    let number: number = 0;

    for (let i = 0; i < bytes.length; i++) {
        number |= (bytes[bytes.length - i - 1] << (8 * i));
    }

    return number;
};

export const NumberToByteArray = (number: number, count: number): number[] => {
    const bytes: number[] = [];

    for (let i = count - 1; i >= 0; i--) {
        bytes.push((number >> (8 * i)) & 0xFF);
    }

    return bytes;
};
